/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceNameRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceNameRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceNameRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceNameRegexQueryOperator>): ResourceNameRegexQueryOperator {
        let obj = Object.assign(new ResourceNameRegexQueryOperator(), model);
        ResourceNameRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceNameRegexQueryOperator>): ResourceNameRegexQueryOperator {
        if (!model) return null;
        return ResourceNameRegexQueryOperator.newInstance(<ResourceNameRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceNameRegexQueryOperator) {
        if (!obj) return;

        models.ResourceNameRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceNameRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceNameRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_name_regex) {
            models.Regex.fixupPrototype(this.resource_name_regex);
        }
    }

    /**
     * Resource name by regex match
     */
    resource_name_regex: models.Regex;

}
